module.exports = __webpack_public_path__ + "static/media/places_icon.20576e67.svg";